import React, { useState, useEffect } from "react";
import "./Training.css";

export default function Training() {
  const [trainingData, setTrainingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTrainingTimes = async () => {
      try {
        const response = await fetch("/data/trainingTimes.json");
        if (!response.ok) throw new Error("Fehler beim Laden der Trainingszeiten");
        const data = await response.json();
        setTrainingData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTrainingTimes();
  }, []);

  if (loading) return <main className="training-container"><p>Trainingszeiten laden...</p></main>;
  if (error) return <main className="training-container"><p>Fehler: {error}</p></main>;
  if (!trainingData) return null;

  return (
    <main className="training-container">
      <h1>Training</h1>
      <section id="team">
        <h2>Unser Trainerteam</h2>
        <ul className="trainer-list">
          <li>
            <strong>Martin</strong>
            <br />
            Unser Tauchlehrer
          </li>
          <li>
            <strong>Jacqueline</strong>
            <br />
            Unsere Tauchlehrerin
          </li>
          <li>
            <strong>Wolfgang</strong>
            <br />
            Unser Übungsleiter
          </li>
          <li>
            <strong>Dagmar</strong>
            <br />
            Unsere Übungsleiterin
          </li>
          <li>
            <strong>Hajo</strong>
            <br />
            Unser Übungsleiter
          </li>
          <li>
            <strong>Vanessa</strong>
            <br />
            Unsere Übungsleiterin
          </li>
        </ul>
      </section>

      <section id="konzept">
        <h2>Trainingskonzept</h2>
        <p>
          Das Training besteht bei uns aus Flossenschwimmen / Schnorcheln und
          Tauchen mit der ABC-Ausrüstung (Flossen, Maske, Schnorchel). Im
          regelmäßigen Training wollen wir unsere Technik und Kondition
          verbessern, um mehr Freude am nächsten Tauchgang zu haben oder einfach
          nur aus Spaß an der Bewegung im und unter Wasser. Zu bestimmten
          Anlässen bringen wir eine komplette Tauchausrüstung (Flasche,
          Tarierweste, Atemregler etc.) mit und üben das Tauchen mit dieser
          Ausrüstung.
        </p>
      </section>

      <section id="zeiten">
        <h2>Trainingszeiten</h2>

        <h3>Hallenbadsaison</h3>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Wann?</th>
                <th>Wo?</th>
                <th>Trainingsmöglichkeit</th>
              </tr>
            </thead>
            <tbody>
              {trainingData.homePageSessions.hallenbad.map((session) => (
                <tr key={session.id}>
                  <td>{session.day}</td>
                  <td>
                    {session.location}
                    <br />
                    {session.address}
                  </td>
                  <td>{session.facility}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <h3>Freibadsaison</h3>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Wann?</th>
                <th>Wo?</th>
                <th>Trainingsmöglichkeit</th>
              </tr>
            </thead>
            <tbody>
              {trainingData.homePageSessions.freibad.map((session) => (
                <tr key={session.id}>
                  <td>{session.day}</td>
                  <td>
                    {session.location}
                    <br />
                    {session.address}
                  </td>
                  <td>{session.facility}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p style={{ marginTop: "1rem" }}>
          Wir treffen uns etwa 10 Minuten vor Trainingsbeginn vor dem Eingang
          und gehen gemeinsam ins Schwimmbad. Neue Teilnehmer sind nach
          Anmeldung herzlich willkommen, an einem Schnuppertraining
          teilzunehmen.
        </p>
      </section>

      <section id="schnuppertraining">
        <h2>Schnuppertraining</h2>
        <p>
          Wir bieten Dir die Möglichkeit, uns innerhalb von drei kostenfreien
          Schnuppertrainings unverbindlich kennenzulernen. Neue Teilnehmer
          melden sich bitte vorher über das{" "}
          <a href="/kontakt">Kontaktformular </a>
          oder per E-Mail bei unseren Trainern an. Teile bitte auch mit, ob Du
          eine Leih-ABC-Ausrüstung benötigst.
        </p>
      </section>
    </main>
  );
}
